import axios from "axios";

//BaseURL backend
const instance = axios.create({
  baseURL: "https://flybysms-backend-v1-ldlr.onrender.com",
  // baseURL: process.env.VUE_APP_API_BASE_URL,
});

instance.interceptors.request.use((config) => {
  let token;
  const userString = localStorage.getItem("user");

  if (userString) {
    token = JSON.parse(userString).token;
  }

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default instance;
